<span class="{{ type }}">
  @switch (type) { @case ('ok') {
  <icon class="d-inline d-sm-none" type="check2" matTooltip="ok"></icon>
  } @case ('done') {
  <icon class="d-inline d-sm-none" type="check2" matTooltip="done"></icon>
  } @case ('cancel') {
  <icon class="d-inline d-sm-none" type="ban" matTooltip="cancel"></icon>
  } @case ('edit') {
  <icon class="d-inline d-sm-none" type="pencil-fill" matTooltip="edit"></icon>
  } @case ('remove') {
  <icon class="d-inline d-sm-none" type="x" matTooltip="remove"></icon>
  } @default {
  <icon class="d-inline d-sm-none" type="check2"></icon>
  } }

  <span class="d-none d-sm-block" #content><ng-content></ng-content></span>
</span>
